import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectTeachers,
  tryGetTeacherByBOHeader,
} from "../../store/slices/teacher";
import {
  tryGetTeacherMails,
  selectTeacherMails,
  selectTreasuryCases,
  selectTeachersReport,
  tryExportTeachersAll,
  tryGetTeachersReport,
  selectExportedTeachers,
  trySendCasesToTreasury,
} from "../../store/slices/backoffice-teachers";
import {
  Box,
  Chip,
  Grow,
  Grid,
  Alert,
  Paper,
  Popper,
  Button,
  Dialog,
  Tooltip,
  MenuItem,
  MenuList,
  AlertTitle,
  Typography,
  DialogTitle,
  IconButton,
  DialogActions,
  useMediaQuery,
  ClickAwayListener,
} from "@mui/material";
import {
  Email,
  Download,
  Payments,
  MoreHoriz,
  PersonAdd,
  Assessment,
} from "@mui/icons-material";
import TeachersListSkeleton from "./skeleton";
import { useNavigate } from "react-router";
import { NameTypography } from "../layout/name-display";
import CustomColumnMenu from "../layout/grid-column-menu";
import { DataGrid, GridToolbarQuickFilter } from "@mui/x-data-grid";
import ModalMessages from "../layout/modal-messages";
import Spinner from "../layout/spinner";
import TeacherMailsModal from "./modal/teacherMailsModal";

const BackOfficeTeachersList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isMobile = useMediaQuery('(max-width:600px)');

  //MANEJO DE ENVIAR PAGOS A TESORERIA
  const [openAlertDialog, setOpenAlertDialog] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const treasuryCases = useSelector(selectTreasuryCases);

  //TRAE EL DETALLE DE MAILS
  const teacherEmails = useSelector(selectTeacherMails);

  //TRAE EL DETALLE DE LOS REPORTES
  const downloadedReport = useSelector(selectTeachersReport);

  //TRAE EL DETALLE DE LOS PROFESORES
  const teachers = useSelector(selectTeachers);

  //TRAE EL DETALLE DE LOS PROFESORES EXPORTADOS
  const exportedTeachers = useSelector(selectExportedTeachers);

  //MANEJO MODAL MAILS
  const [open, setOpen] = useState(false);
  const [mails, setMails] = useState(null);

  //MANEJO DE LAS COLUMNAS
  const [rows, setRows] = useState([]);

  useEffect(() => {
    dispatch(tryGetTeacherByBOHeader());
  }, []);

  useEffect(() => {
    if (teachers?.data) {
      setRows(
        teachers.data.map((x) => {
          return {
            clientId: x.clientId,
            fullName: x.fullName,
            email: x.email ? x.email.toString().trim().toLowerCase() : "",
            statusCli: x.statusCli,
            cliAdderessId: x.cliAdderessId,
            phoneNumber: x.phoneNumber,
            teacherId: x.teacherId,
            cuil: addDashes(x.cuil),
            dictation: x.dictation,
            userId: x.userId,
            username: x.username ? x.username.toString().trim().toLowerCase() : "",
            unansweredTicket: x.unansweredTicket,
            statusCliId: x.statusCliId,
          };
        })
      );
    }
  }, [teachers]);

  //EXPORTA EL LISTADO DE PROFESORES
  const handleClickExport = async () => {
    const action = await dispatch(tryExportTeachersAll());
    if (action.payload?.data?.isValid) window.open(action.payload.data.data.file);
  };

  //DESCARGA EL REPORTE DE PROFESORES
  const handleClickReport = async () => {
    const action = await dispatch(tryGetTeachersReport());
    if (action.payload?.data?.isValid) window.open(action.payload.data.data.file);
  };

  //ENVIA LAS FACTURAS APROBADAS A TESORERIA Y DESCARGA EL REPORTE
  const hanldleCliclTreasuryCases = async () => {
    setOpenAlertDialog(false);
    const request = 0;
    const action = await dispatch(trySendCasesToTreasury(request));
    if (action.payload?.data?.isValid) setOpenDialog(true);
    window.open(action.payload.data.data.file);
  };

  //AGREGA GUIONES A LOS CUILS
  function addDashes(number) {
    if (!number) return "";
    let strNumber = typeof number !== "string" ? number.toString() : number;
    if (strNumber.length <= 2) return strNumber;
    const pre = strNumber.slice(0, 2);
    const mid = strNumber.slice(2, -1);
    const last = strNumber.slice(-1);
    return `${pre}-${mid}-${last}`;
  }

  //ACCIONES Y COLUMNAS
  const initializeDataGrid = () => {
    return {
      columns: {
        columnVisibilityModel: {
          courseId: false,
          teacherId: false,
          teacherCourseId: false,
          courseGroupId: false,
          amountCommited: false,
          userId: false,
          clientId: false,
          username: false,
          dictation: !isMobile,
          phoneNumber: !isMobile,
          unansweredTicket: !isMobile,
          statusCliId: !isMobile,
          email: !isMobile,
          cuil: !isMobile,
          actions: !isMobile,
        },
      },
      pagination: { paginationModel: { pageSize: 10 } },
    };
  };

  //NAVEGAR A TEACHERS
  const navigateNewTeacher = () => {
    navigate("/backoffice/newteacher");
  };

  //BOTON DE ACCIONES
  const ActionsRow = ({ item }) => {
    const anchorRef = useRef(null);
    const [openMenu, setOpenMenu] = useState(false);

    const handleMenuItemClick = (event, index) => {
      //ADMINISTRAR PROFESOR
      if (index === 0) {
        navigate("/teachers", {
          state: {
            teacherId: item.row.teacherId,
            userId: item.row.userId,
            clientId: item.row.clientId,
            username: item.row.username,
          },
        });
      }
      setOpenMenu(false);
    };

    const handleToggle = () => setOpenMenu((prevOpen) => !prevOpen);

    const handleClose = (event) => {
      if (anchorRef.current && anchorRef.current.contains(event.target)) return;
      setOpenMenu(false);
    };

    return (
      <>
        <IconButton
          size="small"
          ref={anchorRef}
          aria-controls={openMenu ? "split-button-menu" : undefined}
          aria-expanded={openMenu ? "true" : undefined}
          aria-label="Acciones"
          aria-haspopup="menu"
          onClick={handleToggle}
          sx={{
            padding: "4px",
            backgroundColor: "#225275",
            color: "white",
            borderRadius: "4px",
            "&:hover": {
              backgroundColor: "#173b54",
            }
          }}
        >
          <MoreHoriz />
        </IconButton>

        <Popper
          sx={{ zIndex: 10 }}
          open={openMenu}
          anchorEl={anchorRef.current}
          role={undefined}
          transition
          placement="left-start"
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin: placement === "bottom" ? "center top" : "center bottom",
              }}
            >
              <Paper elevation={6}>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList id="split-button-menu">
                    <MenuItem key="adminTeacher" onClick={(event) => handleMenuItemClick(event, 0)}>
                      Administrar Profesor
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </>
    );
  };

  //MANEJO SELECCION DE EMAILS
  const handleClickEmails = async (isActive) => {
    const action = await dispatch(tryGetTeacherMails(isActive));
    if (action.payload?.data?.isValid) {
      setMails(action.payload.data.data);
      setOpen(true);
    }
  };

  const CustomToolbar = React.useCallback(() => {
    return (
      <Box sx={{ p: 2, display: "flex", justifyContent: isMobile ? "center" : "flex-start", width: "100%" }}>
        <GridToolbarQuickFilter
          placeholder="Buscar profesor, CUIL, correo..."
          variant="outlined"
          size="small"
          sx={{ 
            width: isMobile ? "100%" : "300px",
            pb: 1
          }}
        />
      </Box>
    );
  }, [isMobile]);

  const chipColorsState = {
    1: "success",
    2: "error",
    3: "warning",
  };

  const columns = React.useMemo(() => [
    { field: "username", headerName: "username", flex: 1, filterable: false },
    { field: "clientId", headerName: "clientId", flex: 1, filterable: false },
    { field: "teacherId", headerName: "teacherId", flex: 1, filterable: false },
    { field: "userId", headerName: "userId", flex: 1, filterable: false },
    {
      field: "fullName",
      headerName: isMobile ? "Detalle del Profesor" : "Nombre Completo",
      flex: isMobile ? 1 : 2,
      headerClassName: "headRow",
      align: "left",
      headerAlign: isMobile ? "center" : "left",
      renderCell: (params) => {
        if (!isMobile) return <NameTypography variant="body2">{params.value}</NameTypography>;

        const chipColor = chipColorsState[params.row.statusCliId] || "default";

        return (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              textAlign: "left",
              width: "100%",
              position: "relative",
              pt: 2,
              pb: 3, 
              pr: 2,
              boxSizing: "border-box" 
            }}
          >
            <Box sx={{ position: "absolute", right: -8, top: 4 }}>
              <ActionsRow item={params} />
            </Box>

            <NameTypography
              variant="subtitle2"
              sx={{
                fontWeight: 800,
                color: "text.primary",
                mb: 2,
                width: "100%"
              }}
            >
              {params.value}
            </NameTypography>

            <Typography variant="caption" color="textSecondary" display="block" sx={{ width: "100%" }}>
              {params.row.cuil}
            </Typography>

            <Typography variant="caption" color="textSecondary" display="block" sx={{ pb: 1.5, width: "100%" }}>
              {params.row.email}
            </Typography>

            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, justifyContent: "flex-start", width: "100%" }}>
              <Chip label={params.row.statusCli} color={chipColor} size="small" />
              {params.row.dictation && <Chip label="Dictando" color="warning" size="small" />}
              {params.row.unansweredTicket && <Chip label="Msj Pend." color="warning" size="small" />}
              {params.row.phoneNumber && <Chip label={params.row.phoneNumber} variant="outlined" size="small" />}
            </Box>
          </Box>
        );
      },
    },
    { field: "email", headerName: "Correo Electrónico", flex: 2, headerClassName: "headRow" },
    { field: "cuil", headerName: "CUIL/CUIT", flex: 2, headerClassName: "headRow" },
    { field: "phoneNumber", headerName: "Teléfono", flex: 1, headerClassName: "headRow", filterable: false },
    {
      field: "dictation",
      headerAlign: "center", align: "center", headerName: "Dictando", flex: 1, headerClassName: "headRow", filterable: false,
      renderCell: (params) => <Chip label={params.value ? "Sí" : "No"} color={params.value ? "warning" : "success"} size="small" />
    },
    {
      field: "unansweredTicket",
      headerAlign: "center", align: "center", headerName: "Msj Pend.", flex: 1, headerClassName: "headRow", filterable: false,
      renderCell: (params) => <Chip label={params.value ? "Sí" : "No"} color={params.value ? "warning" : "success"} size="small" />
    },
    {
      field: "statusCliId",
      headerAlign: "center", align: "center", flex: 1, minWidth: 10, headerName: "Estado", headerClassName: "headRow", filterable: false,
      renderCell: (params) => {
        if (params.value === null) return "";
        const chipColor = chipColorsState[params.row.statusCliId] || "default";
        return <Chip label={params.row.statusCli} color={chipColor} size="small" />;
      },
    },
    { field: "actions", headerAlign: "center", headerName: "", width: 60, minWidth: 60, headerClassName: "headRow", filterable: false, align: "center", renderCell: (params) => <ActionsRow item={params} /> },
  ], [isMobile]);

  return (
    <>
      {teachers.isLoading ? (
        <TeachersListSkeleton />
      ) : (
        <>
          <Grid container spacing={3} sx={{ pt: 3, pb: 3, minWidth: 0 }}>
            <Grid item xs={12} lg={2}>
              <Typography align="left" style={{ fontWeight: "bold", fontSize: 18 }} variant="h6" component="h1">
                Profesores
              </Typography>
            </Grid>

            <Grid item xs={12} lg={10}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  justifyContent: "flex-end",
                  flexWrap: "wrap",
                  gap: 1.5,
                }}
              >
                <Button
                  size="small"
                  variant="contained"
                  fullWidth={isMobile}
                  disabled={treasuryCases.isLoading}
                  endIcon={<Payments />}
                  onClick={() => setOpenAlertDialog(true)}
                  color="warning"
                >
                  {treasuryCases.isLoading && <Spinner color="primary" />} ENVIAR PAGOS
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  fullWidth={isMobile}
                  disabled={teacherEmails.isLoading}
                  endIcon={<Email />}
                  onClick={() => handleClickEmails(false)}
                >
                  {teacherEmails.isLoading && <Spinner color="primary" />} CORREOS TODOS
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  fullWidth={isMobile}
                  disabled={teacherEmails.isLoading}
                  endIcon={<Email />}
                  onClick={() => handleClickEmails(true)}
                >
                  {teacherEmails.isLoading && <Spinner color="primary" />} CORREOS DICTANDO
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  fullWidth={isMobile}
                  disabled={teachers.isLoading || exportedTeachers.isLoading}
                  endIcon={<Download />}
                  onClick={() => handleClickExport()}
                >
                  {exportedTeachers.isLoading && <Spinner color="primary" />} EXPORTAR
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  fullWidth={isMobile}
                  disabled={teachers.isLoading || exportedTeachers.isLoading || downloadedReport.isLoading}
                  endIcon={<Assessment />}
                  onClick={() => handleClickReport()}
                >
                  {downloadedReport.isLoading && <Spinner color="primary" />} REPORTE
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  fullWidth={isMobile}
                  color="success"
                  endIcon={<PersonAdd />}
                  onClick={navigateNewTeacher}
                >
                  CARGAR PROFESOR
                </Button>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <DataGrid
                slots={{ 
                  columnMenu: CustomColumnMenu,
                  toolbar: CustomToolbar 
                }}
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: { debounceMs: 500 },
                  },
                }}
                autoHeight={true}
                rowSelection={false}
                getRowId={(row) => `${row.clientId}-${row.teacherId}-${row.cuil}`}
                disableRowSelectionOnClick
                rows={rows}
                columns={columns}
                pageSizeOptions={[5, 10, 25, 50]}
                initialState={initializeDataGrid()}
                getRowHeight={() => (isMobile ? "auto" : undefined)}
                getEstimatedRowHeight={() => isMobile ? 350 : 140}
                sx={{
                  "& .MuiTablePagination-spacer": {
                    display: isMobile ? "none" : "block",
                  },
                  "& .MuiTablePagination-selectLabel": {
                    display: isMobile ? "none" : "block",
                  },
                  "& .MuiTablePagination-select": {
                    display: isMobile ? "none" : "flex",
                  },
                  "& .MuiDataGrid-footerContainer": {
                    justifyContent: isMobile ? "center" : "flex-end",
                  },
                  "& .MuiTablePagination-toolbar": {
                    justifyContent: isMobile ? "center" : "flex-end",
                    width: isMobile ? "100%" : "auto",
                    paddingLeft: isMobile ? 0 : 2,
                  },
                }}
              />
            </Grid>
          </Grid>

          {teachers.errors?.length > 0 && <ModalMessages errors={teachers.errors} />}
          {treasuryCases.errors?.length > 0 && <ModalMessages errors={treasuryCases.errors} />}
        </>
      )}

      {openAlertDialog && (
        <Dialog open={openAlertDialog}>
          <DialogTitle id="alert-dialog-title">
            <Alert severity="warning">
              <AlertTitle>¡Advertencia!</AlertTitle>
              Al continuar con esta acción, se enviarán a tesorería todas las facturas que actualmente se encuentran en estado "Aprobado".
              <br />
              Este proceso es irreversible y las facturas enviadas a tesorería no podrán ser revertidas.
              <br />
              ¿Estás seguro de que deseas continuar?
            </Alert>
          </DialogTitle>
          <DialogActions>
            <Button sx={{ color: "warning.main" }} onClick={() => hanldleCliclTreasuryCases()} autoFocus>
              Aceptar
            </Button>
            <Button onClick={() => setOpenAlertDialog(false)} autoFocus>
              Cancelar
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {openDialog && (
        <Dialog open={openDialog} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
          <DialogTitle id="alert-dialog-title">
            {"El proceso ha finalizado con éxito"}
          </DialogTitle>
          <DialogActions>
            <Button onClick={() => setOpenDialog(false)} autoFocus>
              Aceptar
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {open && <TeacherMailsModal mails={mails} open={open} setOpen={setOpen} />}
    </>
  );
};

export default BackOfficeTeachersList;